import { fetchRewardOverview } from '~/api/promo'
import type { RewardOverviewModuleDto } from '~/types/api/promo'

/**
 * GET /rewards/overview：五模块可领角标（promo/task/vip_salary/refer/rakeback）。
 * 页签角标按 module（= 栏目清单 symbol）撮合 claimable_count。
 * useState 跨组件共享；由 promo 页进入时统一拉取，领取后各面板再调 load() 刷新。
 */
/** 并发去重：页面进入时 owner 与面板可能同时调 load()，共享同一请求 */
let overviewInflight: Promise<void> | null = null

export function useRewardOverview() {
  const modules = useState<RewardOverviewModuleDto[]>('reward-overview-modules', () => [])
  const hasPending = useState('reward-overview-has-pending', () => false)

  const load = () => {
    if (!overviewInflight) {
      overviewInflight = (async () => {
        try {
          const res = await fetchRewardOverview()
          modules.value = res.modules ?? []
          hasPending.value = res.has_pending ?? false
        } catch (e) {
          // 拦截器已 toast；失败时保留旧值，角标不闪没
          console.error('[rewards] fetch overview failed:', e)
        } finally {
          overviewInflight = null
        }
      })()
    }
    return overviewInflight
  }

  /** 页签角标：按 symbol 找模块的 claimable_count；没有该模块 = 0（不显示） */
  const badgeOf = (symbol: string) =>
    modules.value.find(m => m.module === symbol)?.claimable_count ?? 0

  return { modules, hasPending, badgeOf, load }
}
